// extracted by mini-css-extract-plugin
export default {"root":"SectionCard_root__8gilm","title":"SectionCard_title__38X7P"};